import { Link } from 'react-router-dom';
import type { Movie } from '@/mocks/movies';

interface MovieCardProps {
  movie: Movie;
}

export default function MovieCard({ movie }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-300 hover:-translate-y-1"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={movie.cover}
          alt={`${movie.title} 影视封面`}
          title={`${movie.title} 剧情介绍`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md text-xs font-semibold bg-primary-500/90 text-white backdrop-blur">
          {movie.category}
        </span>
        <span className="absolute top-2 right-2 px-2 py-0.5 rounded-md text-xs font-bold bg-accent-500 text-white">
          {movie.rating.toFixed(1)}
        </span>
        <div className="absolute inset-0 bg-gradient-to-t from-primary-950/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
          <span className="flex items-center gap-1.5 text-white text-sm font-medium">
            <i className="ri-play-circle-fill text-lg"></i> 查看详情
          </span>
        </div>
      </div>
      <div className="p-3 md:p-4">
        <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-950 truncate group-hover:text-primary-600 transition-colors">
          {movie.title}
        </h3>
        <div className="flex items-center gap-2 mt-1.5 text-xs text-foreground-500">
          <span>{movie.year}</span>
          <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
          <span className="truncate">{movie.duration}</span>
        </div>
        <div className="flex flex-wrap gap-1.5 mt-2.5">
          {movie.genres.slice(0, 3).map((g) => (
            <span
              key={g}
              className="px-2 py-0.5 rounded-md text-xs bg-secondary-100 text-secondary-900"
            >
              {g}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}